import "./style/main.css"
import Navbar from "./Components/Navbar/Navbar"
import Footer from "./Components/Footer/footer";
import ProjectPortfolio from "./pages/Project";
import Skill from "./pages/Skills";
import Contact from "./pages/Contacts";
import AloneProject from "./pages/AloneProject";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./utils/scrolToTop";

function App() {
  return (

    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<ProjectPortfolio />}/>
          <Route path="/skill" element={<Skill />}/>
          <Route path="/contacts" element={<Contact />}/>
          <Route path="/aloneproject/:id" element={<AloneProject />}/>
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
